/*!

=========================================================
* Black Dashboard React v1.0.0
=========================================================

* Product Page: /product/black-dashboard-react
* Copyright 2019 SecurePoint 360 ()
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by SecurePoint 360

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React, { Suspense } from 'react';
import { NavLink, Link } from 'react-router-dom';
// nodejs library to set properties for components
import { PropTypes } from 'prop-types';

// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from 'perfect-scrollbar';

// reactstrap components
import { Nav } from 'reactstrap';

import './styles.css';
import LogoCompaniesDropdown from 'components/LogoDropdown/LogoDropdown';

var ps;

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.activeRoute.bind(this);
  }
  // verifies if routeName is the one active (in browser input)
  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? 'active' : '';
  }
  componentDidMount() {
    // if (navigator.platform.indexOf("Win") > -1) {
    // console.log(this.refs.sidebar)
    // window.PerfectScrollbar = PerfectScrollbar
    ps = new PerfectScrollbar('#innernav', {
      suppressScrollX: true,
      suppressScrollY: false,
      // wheelSpeed: 2,
      wheelPropagation: true,
    });
    // }
  }
  componentWillUnmount() {
    // if (navigator.platform.indexOf("Win") > -1) {
    ps.destroy();
    // }
  }
  linkOnClick = () => {
    document.documentElement.classList.remove('nav-open');
  };
  renderIcon(prop) {
    if (prop.icon && prop.icon.length > 3) {
      return <i className={prop.icon} />;
    } else {
      return <i className="custom-icon-text">{prop.icon}</i>;
    }
  }
  render() {
    const { bgColor, routes, rtlActive, logo } = this.props;
    let logoImg = null;
    let logoText = null;
    if (logo !== undefined) {
      if (logo.outterLink !== undefined) {
        logoImg = (
          <a
            href={logo.outterLink}
            className="simple-text logo-mini"
            onClick={this.props.toggleSidebar}
          >
            <div className="logo-img">
              <img src={logo.imgSrc} alt="company-logo" />
            </div>
          </a>
        );
      } else {
        logoImg = (
          <Link
            to={logo.innerLink}
            className="simple-text logo-mini"
            onClick={this.props.toggleSidebar}
          >
            <div className="logo-img">
              <img src={logo.imgSrc} alt="company-logo" />
            </div>
          </Link>
        );
        logoText = (
          <Link
            to={logo.innerLink}
            className="simple-text logo-normal"
            onClick={this.props.toggleSidebar}
          >
            {logo.text}
          </Link>
        );
      }
    }

    return (
      <div className="sidebar" data={bgColor}>
        <div className="sidebar-wrapper" ref="sidebar">
          <div className="company-name">
            <Suspense fallback={<>Loading...</>}>
              <LogoCompaniesDropdown
                setCurrentCompany={this.props.setCompanyData}
              />
            </Suspense>
          </div>
          {logoImg !== null || logoText !== null ? (
            <div className="logo">
              {logoImg}
              {logoText}
            </div>
          ) : null}
          <Nav id="innernav">
            {routes.map((prop, key) => {
              if (prop.redirect) return null;
              if (prop.sidebar == false) return null;
              if (prop.admin == true) return null;
              return (
                <li
                  className={
                    this.activeRoute(prop.path) +
                    (prop.pro ? ' active-pro' : '')
                  }
                  key={key}
                >
                  {window.location.pathname == prop.layout + prop.path ? (
                    <a href={prop.layout + prop.path}>
                      {this.renderIcon(prop)}
                      <p id={'Sidebar' + prop.name}>
                        {rtlActive ? prop.rtlName : prop.name}
                      </p>
                    </a>
                  ) : (
                    <NavLink
                      to={
                        window.location.pathname == prop.layout + prop.path
                          ? prop.layout + prop.path + '/?reload=true'
                          : prop.layout + prop.path
                      }
                      className="nav-link"
                      activeClassName="active"
                      onClick={this.props.toggleSidebar}
                    >
                      {this.renderIcon(prop)}
                      <p id={'Sidebar' + prop.name}>
                        {rtlActive ? prop.rtlName : prop.name}
                      </p>
                    </NavLink>
                  )}
                </li>
              );
            })}
            <hr />
            {routes.map((prop, key) => {
              if (prop.redirect) return null;
              if (prop.sidebar == false) return null;
              if (prop.admin != true) return null;
              return (
                <li
                  className={
                    this.activeRoute(prop.path) +
                    (prop.pro ? ' active-pro' : '')
                  }
                  key={key}
                >
                  {window.location.pathname == prop.layout + prop.path ? (
                    <a href={prop.layout + prop.path}>
                      {this.renderIcon(prop)}
                      <p id={'Sidebar' + prop.name}>
                        {rtlActive ? prop.rtlName : prop.name}
                      </p>
                    </a>
                  ) : (
                    <NavLink
                      to={
                        window.location.pathname == prop.layout + prop.path
                          ? prop.layout + prop.path + '/?reload=true'
                          : prop.layout + prop.path
                      }
                      className="nav-link"
                      activeClassName="active"
                      onClick={this.props.toggleSidebar}
                    >
                      {this.renderIcon(prop)}
                      <p id={'Sidebar' + prop.name}>
                        {rtlActive ? prop.rtlName : prop.name}
                      </p>
                    </NavLink>
                  )}
                </li>
              );
            })}
          </Nav>
        </div>
      </div>
    );
  }
}

Sidebar.defaultProps = {
  rtlActive: false,
  bgColor: 'primary',
  routes: [{}],
};

Sidebar.propTypes = {
  // if true, then instead of the routes[i].name, routes[i].rtlName will be rendered
  // insde the links of this component
  rtlActive: PropTypes.bool,
  bgColor: PropTypes.oneOf(['primary', 'blue', 'green']),
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the text of the logo
    text: PropTypes.node,
    // the image src of the logo
    imgSrc: PropTypes.string,
  }),
};

export default Sidebar;
